var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "50%" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-1",
                  attrs: { icon: "", color: "red" },
                  on: { click: _vm.onClose },
                },
                [_c("v-icon", [_vm._v("mdi-close")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "py-0" },
            [
              _c(
                "v-slide-group",
                { attrs: { "active-class": "success", "show-arrows": "" } },
                _vm._l(_vm.characters, function (character) {
                  return _c(
                    "v-slide-item",
                    { key: character.code },
                    [
                      character.code != 0
                        ? _c(
                            "v-card",
                            {
                              staticClass: "ma-1",
                              attrs: {
                                color:
                                  _vm.model == character.code
                                    ? "green"
                                    : "lighten-1",
                                elevation: "0",
                                height: "150",
                                width: "150",
                                outlined: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSelect(character.code)
                                },
                              },
                            },
                            [
                              _vm.getUrl(character.key) == undefined
                                ? _c("v-progress-circular", {
                                    staticStyle: {
                                      "margin-top": "60px",
                                      "margin-left": "55px",
                                    },
                                    attrs: {
                                      indeterminate: "",
                                      color: "orange",
                                    },
                                  })
                                : _c("v-img", {
                                    attrs: {
                                      "max-width": "150",
                                      src: _vm.getUrl(character.key),
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "ma-2",
                  attrs: { color: "primary" },
                  on: { click: _vm.onPressSave },
                },
                [_vm._v("Set ")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }